(function () {
  'use strict';

  var config = window.NaviraModelAvailability || {};
  var databaseUrl = String(config.databaseUrl || '').trim();
  var notAvailableUrl = String(config.notAvailableUrl || '/pages/kit-not-available').trim();
  if (!databaseUrl) return;

  function clean(value) {
    return String(value || '').replace(/^\uFEFF/, '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function key(value) {
    return clean(value).toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function textKey(value) {
    return clean(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function pathKey(value) {
    var raw = clean(value);
    if (!raw || raw === '#') return '';
    try {
      return new URL(raw, window.location.origin).pathname.replace(/\/+$/, '').toLowerCase() || '/';
    } catch (error) {
      return '';
    }
  }

  function parseCSV(text) {
    var rows = [], row = [], field = '', quoted = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i], next = text[i + 1];
      if (c === '"') {
        if (quoted && next === '"') { field += '"'; i++; } else { quoted = !quoted; }
      } else if (c === ',' && !quoted) {
        row.push(field); field = '';
      } else if ((c === '\n' || c === '\r') && !quoted) {
        row.push(field);
        if (row.some(function (cell) { return clean(cell); })) rows.push(row);
        row = []; field = '';
        if (c === '\r' && next === '\n') i++;
      } else {
        field += c;
      }
    }
    row.push(field);
    if (row.some(function (cell) { return clean(cell); })) rows.push(row);
    return rows;
  }

  function objects(rows) {
    if (!rows.length) return [];
    var headers = rows[0].map(key);
    return rows.slice(1).map(function (row) {
      var item = {};
      headers.forEach(function (header, index) { item[header] = clean(row[index]); });
      return item;
    });
  }

  function landingUrl(row) {
    return row.model_landing_url || row.model_url || row.landing_url || row.page_url || '';
  }

  function isAvailable(row) {
    if (Object.prototype.hasOwnProperty.call(row, 'available')) {
      return clean(row.available).toUpperCase() === 'TRUE';
    }
    return clean(row.availability).toLowerCase() === 'available';
  }

  function clearPendingState() {
    document.documentElement.classList.remove('navira-model-check-pending');
  }

  function isPendingModelLanding() {
    return document.documentElement.classList.contains('navira-model-check-pending');
  }

  function redirectNotAvailable(label) {
    window.location.replace(notAvailableUrl + '?model=' + encodeURIComponent(label || document.title || window.location.pathname));
  }

  function modelStatuses(rows) {
    var statuses = {};
    rows.forEach(function (row) {
      var name = textKey([row.shipyard, row.model].join(' '));
      if (!name) return;
      statuses[name] = Boolean(statuses[name] || isAvailable(row));
    });
    return statuses;
  }

  function hideUnavailableSearchLinks(statusByPath, statusByModel) {
    var hidden = 0;
    document.querySelectorAll('a[href]').forEach(function (anchor) {
      var path = pathKey(anchor.getAttribute('href'));
      var unavailable = Boolean(path && Object.prototype.hasOwnProperty.call(statusByPath, path) && !statusByPath[path]);
      if (!unavailable) {
        var label = textKey([anchor.textContent, anchor.getAttribute('aria-label'), anchor.getAttribute('title')].join(' '));
        Object.keys(statusByModel).some(function (modelName) {
          if (!statusByModel[modelName] && label.indexOf(modelName) !== -1) {
            unavailable = true;
            return true;
          }
          return false;
        });
      }
      if (!unavailable) return;
      var item = anchor.closest('li, [class*="resource-list__item"], [class*="search-result"], [class*="predictive-search"]');
      var target = item || anchor;
      if (!target.hasAttribute('hidden')) target.setAttribute('hidden', 'hidden');
      if (target.getAttribute('aria-hidden') !== 'true') target.setAttribute('aria-hidden', 'true');
      hidden++;
    });
    return hidden;
  }

  function showNotAvailableState(rows) {
    var params = new URLSearchParams(window.location.search || '');
    var query = textKey(params.get('q') || '');
    if (!query) return;

    var unavailableMatch = rows.some(function (row) {
      if (isAvailable(row)) return false;
      var name = textKey([row.shipyard, row.model, row.year_display].join(' '));
      return name.indexOf(query) !== -1 || query.indexOf(textKey(row.model)) !== -1;
    });
    var availableMatch = rows.some(function (row) {
      if (!isAvailable(row)) return false;
      return textKey([row.shipyard, row.model, row.year_display].join(' ')).indexOf(query) !== -1;
    });
    if (!unavailableMatch || availableMatch || document.querySelector('[data-navira-model-not-available]')) return;

    var host = document.querySelector('#MainContent');
    if (!host) return;
    var state = document.createElement('div');
    state.setAttribute('data-navira-model-not-available', '');
    state.style.cssText = 'max-width:900px;margin:32px auto;padding:32px 20px;text-align:center;';
    state.innerHTML = '<h1>Model not available</h1><p>This model is not currently available in our catalogue.</p>';
    host.prepend(state);
  }

  fetch(databaseUrl, { credentials: 'omit', cache: 'no-store' })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .then(function (text) {
      var rows = objects(parseCSV(text));
      var statusByPath = {};
      rows.forEach(function (row) {
        [landingUrl(row), row.product_url].forEach(function (url) {
          var path = pathKey(url);
          if (!path) return;
          statusByPath[path] = Boolean(statusByPath[path] || isAvailable(row));
        });
      });
      var statusByModel = modelStatuses(rows);

      var currentPath = pathKey(window.location.pathname);
      if (Object.prototype.hasOwnProperty.call(statusByPath, currentPath) && !statusByPath[currentPath]) {
        redirectNotAvailable(document.title || currentPath);
        return;
      }
      if (isPendingModelLanding() && !Object.prototype.hasOwnProperty.call(statusByPath, currentPath)) {
        redirectNotAvailable(document.title || currentPath);
        return;
      }
      clearPendingState();

      var apply = function () {
        hideUnavailableSearchLinks(statusByPath, statusByModel);
        showNotAvailableState(rows);
      };
      apply();

      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () { queued = false; apply(); });
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function (error) {
      console.warn('Navira model availability database unavailable:', error);
      if (isPendingModelLanding()) redirectNotAvailable(document.title || window.location.pathname);
    });
})();
